'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AvailabilityStatus = require('./components/AvailabilityStatus.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AvailabilityStatus).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/availability-status/lib/index.js
// module id = 361
// module chunks = 1